import { Injectable, Inject, Optional, isDevMode } from '@angular/core';
import { LocaleService } from '@app/core/i18n/services/locale.service';
import { I18N_HOSTNAMES } from '../tokens';
import { environment } from '@env/environment';

@Injectable()
export class UrlGeneratorService {
  private hostnames: Map<string, string> = new Map();
  private devMode = isDevMode();

  constructor(
    private localeService: LocaleService,
    @Optional()
    @Inject('PROTOCOL')
    private protocol: string,
    @Optional()
    @Inject(I18N_HOSTNAMES)
    hostnames: { [locale: string]: string }
  ) {
    if (!hostnames) {
      hostnames = environment.i18n.hosts;
    }
    if (!this.protocol) {
      this.protocol = 'http';
    }

    for (const locale of Object.keys(hostnames)) {
      this.hostnames.set(locale, hostnames[locale]);
    }
  }

  getHostname(locale?: string): string {
    if (typeof locale === 'undefined') {
      locale = this.localeService.getLocale().toString();
    }

    return this.hostnames.get(locale);
  }

  generateUrl(path: string, locale?: string): string {
    const hostname = this.getHostname(locale);
    if (this.devMode || hostname === undefined) {
      return path;
    }

    return this.protocol + '://' + hostname + path;
  }
}
